import { IApiAdjustmentRule, IApiAdjustmentRuleUpdate, IApiRuleId } from '@cbridge-packages/api';
import { RuleTranslator } from '@cbridge-packages/rule';
import { IAdjustmentRule, IAdjustmentImportRule } from './adjustmentRule.interface';

export namespace AdjustmentRuleTranslator {
  export function fromApi(rule: IApiAdjustmentRule): IAdjustmentRule {
    return RuleTranslator.fromApiClientRule(rule);
  }

  export function toApi(rule: IAdjustmentRule): IApiAdjustmentRuleUpdate {
    return RuleTranslator.toApiClientRule(rule);
  }

  export function fromApiImport(rule: IApiAdjustmentRule & IApiRuleId): IAdjustmentImportRule {
    const result: IAdjustmentImportRule = RuleTranslator.fromApiClientRule(rule);
    result.id = rule.id;

    return result;
  }
}
